export default __webpack_public_path__ + "477de1aeadb3108307a02f6ba976e651.png";